var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "div",
        [
          _c(
            "b-button",
            {
              staticClass: "btn-icon rounded-circle p-3",
              attrs: {
                variant: "secondary",
                size: "sm",
                "data-cy": "see-events"
              },
              on: {
                click: function($event) {
                  return _vm.hendleDeleteSuppression()
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "TrashIcon" } })],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }